import { memo } from 'react';
import type { CSSProperties } from 'react';

export default memo(SpinnerThreeDots);

function SpinnerThreeDots({ color, size }: { color: string; size: number }) {
  const dotBase: CSSProperties = {
    width: size,
    height: size,
    background: color,
    borderRadius: '100%',
    animation: 'spinner-bounce 1.4s infinite ease-in-out both',
  };

  return (
    <div className="flex items-center justify-center">
      <div style={{ ...dotBase, animationDelay: '-0.32s' }} />
      <div style={{ ...dotBase, visibility: 'hidden' }} />
      <div style={{ ...dotBase, animationDelay: '-0.16s' }} />
      <div style={{ ...dotBase, visibility: 'hidden' }} />
      <div style={dotBase} />
    </div>
  );
}
